import { useRef } from 'react';
import { validateChangePasswordForm } from '../../../helpers/validationSchemaHelpers';
import { useCurrentUserActions } from '../../auth/useCurrentUserActions';
import { useModal } from '../../modal/useModal';
import { useValidationForm } from '../../useValidationForm';

export const useChangePasswordForm = () => {
  const { hideModal } = useModal();
  const { updatePassword } = useCurrentUserActions();
  const password = useRef({});

  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useValidationForm<{
    password: string;
    newPassword: string;
    retypePassword: string;
    token?: string;
  }>({
    defaultValues: {
      password: '',
      newPassword: '',
      retypePassword: '',
      token: '',
    },
  });

  const submit = (data: {
    password: string;
    newPassword: string;
    retypePassword: string;
    token?: string;
  }) => {
    const validationErrors = validateChangePasswordForm(data, !!data.token);

    if (validationErrors) {
      Object.entries(validationErrors).forEach(([field, message]) => {
        setError(field as keyof typeof data, {
          type: 'manual',
          message,
        });
      });
      return;
    }

    updatePassword({
      newPassword: data.newPassword,
      password: data.password,
      token: data.token,
    });
    hideModal();
  };

  return {
    password,
    handleSubmit: handleSubmit(submit),
    control,
    errors,
  };
};
